import Octicon, { X } from '@githubprimer/octicons-react';
import * as React from 'react';
import { Button } from 'reactstrap';
import AutoSuggestContext, { AutoSuggestContextValue } from './AutoSuggestContext';
import AutoSuggestMenuToggle from './AutoSuggestMenuToggle';
import { toKebabCase } from 'util/StringUtil';

export interface AutoSuggestInputActionsProps {
	disabled: boolean;
	clearable?: boolean;
	name: string;
}

/**
 * Renders the action buttons to clear values and display the autosuggest menu.
 *
 * @class AutoSuggestInputActions
 * @extends {React.Component<AutoSuggestInputActionsProps>}
 */
class AutoSuggestInputActions extends React.Component<AutoSuggestInputActionsProps> {
	public static contextType: React.Context<any> = AutoSuggestContext;
	public declare context: AutoSuggestContextValue;

	public static defaultProps = {
		disabled: false,
		clearable: true,
	};

	/**
	 * Clears out value when the clear button is clicked
	 *
	 * @memberof AutoSuggestInput
	 */
	public handleClear = () => {
		const {
			onChange,
			downshift: { clearSelection },
		} = this.context;

		clearSelection();
		onChange(null);
	};

	public render() {
		const { disabled, clearable, name } = this.props;

		const {
			value,
			downshift: { isOpen, getToggleButtonProps },
		} = this.context;

		// never show the clear button if we're dealing with an array of values (multiple select)
		const hideClearButton = !value || Array.isArray(value) || !clearable;

		if (!hideClearButton) {
			return (
				<Button
					disabled={disabled}
					onClick={this.handleClear}
					title="Remove"
					className="btn-input-surrounded btn-input-cancel"
					data-testid={`remove-autosuggest-btn-${toKebabCase(name)}`}
				>
					<Octicon icon={X} ariaLabel="X" />
				</Button>
			);
		}

		return (
			<AutoSuggestMenuToggle disabled={disabled} isOpen={isOpen} getToggleButtonProps={getToggleButtonProps} />
		);
	}
}

export default AutoSuggestInputActions;
